<template>
    <div class="availability-calendar">
        <!-- Calendar -->
                        <div class="calendar">


                            <!-- Filters -->
                            <div class="row filters mt-3">
                                <div class="col-md-6">
                                    <!-- Persons dropdown -->
                                    <div class="persons-dropdown dropdown" :class="{ open: showDropdown === 'persons' }">
                                        <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton" aria-haspopup="true" aria-expanded="false" @click="togglePersonsDropdown('persons');">
                                            <i class="wa-icon-user" v-if="children.length === 0"></i>
                                            <i class="wa-icon-two-users" v-if="children.length > 0"></i>

                                            {{ adults }} {{ 'checkout.steps.calendar.adults' | choice(adults) }}
                                            <span v-if="children.length > 0">
                                                + {{ children.length }} {{ 'checkout.steps.calendar.children' | choice(children.length) }}
                                            </span>
                                        </button>

                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" :class="{ show: showDropdown === 'persons' }">
                                            <!-- Adults -->
                                            <div class="adults">
                                                <label>
                                                    <i class="wa-icon-user"></i>
                                                    {{ 'nav.filterbar.adults' | trans }}
                                                </label>

                                                <div class="float-right">
                                                    <button type="button" class="btn decrease" @click="adults = (adults > 1 ? adults - 1 : 1)">
                                                        <i class="fa fa-minus"></i>
                                                    </button>

                                                    <span class="amount">{{ adults }}</span>

                                                    <button type="button" class="btn increase" @click="adults++">
                                                        <i class="fa fa-plus"></i>
                                                    </button>
                                                </div>
                                            </div>

                                            <small class="d-block text-center text-muted px-4" v-if="!isChildren">
                                                {{ 'checkout.steps.calendar.noChildrenPossible' | trans }}
                                            </small>

                                            <div class="divider" v-if="isChildren"></div>

                                            <!-- Children -->
                                            <div class="children" v-if="isChildren">
                                                <label>
                                                    <i class="wa-icon-two-users"></i>
                                                    {{ 'nav.filterbar.children' | trans }}
                                                </label>

                                                <div class="float-right">
                                                    <button type="button" class="btn decrease" @click="decreaseChildren()">
                                                        <i class="fa fa-minus"></i>
                                                    </button>

                                                    <span class="amount">{{ children.length }}</span>

                                                    <button type="button" class="btn increase" @click="increaseChildren()">
                                                        <i class="fa fa-plus"></i>
                                                    </button>
                                                </div>

                                                <!-- Children ages -->
                                                <div class="children-age" v-for="(child, index) in children" :class="{ first : index === 0 }" :key="child.id">
                                                    <label>
                                                        {{ 'checkout.steps.calendar.children' | choice(1) }} {{ index + 1 }}
                                                        <small>
                                                            {{ 'checkout.steps.calendar.childrenBirthdate' | trans }}
                                                        </small>
                                                    </label>

                                                    <div class="birthdate">
                                                        <div class="input">
                                                            <input type="number" class="day" min="0" v-model="child.birthdate.day" :placeholder="'checkout.steps.calendar.childrenBirthdateDD' | trans" @keyup="jumpEnterBirthdate" @keydown="validateEnterBirthdate" @focus="clearBirthdateInput($event);child.birthdate.day = null;">
                                                            <input type="number" class="month" min="0" v-model="child.birthdate.month" :placeholder="'checkout.steps.calendar.childrenBirthdateMM' | trans" @keyup="jumpEnterBirthdate" @keydown="validateEnterBirthdate" @focus="clearBirthdateInput($event);child.birthdate.month = null;">
                                                            <input type="number" class="year" min="1940" v-model="child.birthdate.year" :placeholder="'checkout.steps.calendar.childrenBirthdateYYYY' | trans" @keyup="jumpEnterBirthdate" @keydown="validateEnterBirthdate" @focus="clearBirthdateInput($event);child.birthdate.year = null;">
                                                        </div>

                                                        <small class="age" v-if="(child.birthdate.day !== null && child.birthdate.day.length > 0) && (child.birthdate.month !== null && child.birthdate.month.length > 0) && (child.birthdate.year !== null && child.birthdate.year.length === 4)">
                                                            <span v-if="calculateChildAge(child) < 18">
                                                                {{ calculateChildAge(child) }}
                                                                {{ 'checkout.steps.calendar.years' | choice(calculateChildAge(child)) }}
                                                            </span>
                                                            <span class="text-danger" v-if="calculateChildAge(child) >= 18">
                                                                {{ 'checkout.steps.calendar.childIsTooOld' | trans }}
                                                            </span>
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Invalid persons -->
                                            <span class="invalid-persons d-block px-4 text-center text-danger" v-if="!isPersonsValid">
                                                {{ 'checkout.steps.calendar.personsNotValid' | trans }}
                                            </span>

                                            <div class="row apply-cancel">
                                                <div class="col-sm-6 text-center">
                                                    <button type="button" class="btn btn-link text-dark btn-block" @click="togglePersonsDropdown('persons')">
                                                        {{ 'checkout.steps.calendar.personsCancel' | trans }}
                                                    </button>
                                                </div>

                                                <div class="col-sm-6 text-center">
                                                    <button type="button" class="btn btn-link btn-block" @click="applyPersons('persons')">
                                                        <svg v-if="isLoading === 'applyPersons'" class="loader" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
                                                            <circle class="internal-circle" cx="60" cy="60" r="30"></circle>
                                                            <circle class="external-circle" cx="60" cy="60" r="50"></circle>
                                                        </svg>
                                                        <span v-if="!isLoading">{{ 'checkout.steps.calendar.personsApply' | trans }}</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <!-- Nights -->
                                    <div class="nights-dropdown dropdown" :class="{ open: showDropdown === 'nights' }">
                                        <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton" aria-haspopup="true" aria-expanded="false" @click="toggleDropdown('nights');">
                                            <span v-if="filters.nights">
                                                {{ filters.nights }}
                                                {{ 'checkout.steps.calendar.nights' | choice(nights) }}
                                            </span>

                                            <span v-if="! filters.nights">
                                                {{ 'checkout.steps.calendar.selectNights' | trans }}
                                            </span>
                                        </button>

                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" :class="{ show: showDropdown === 'nights' }">
                                            <button class="dropdown-item" type="button" @click="() => {
                                                filters.nights = null
                                                toggleDropdown('nights')
                                            }">
                                                <i class="fa fa-calendar-day font-weight-400 mr-1"></i>
                                                Frei wählen
                                            </button>

                                            <button class="dropdown-item" type="button" :class="{ active: item.amount === filters.nights }" v-for="item in possibleNights" @click="() => {
                                                filters.nights = item.amount
                                                toggleDropdown('nights')
                                            }">
                                                {{ item.amount }}
                                                {{ 'checkout.steps.calendar.nights' | choice(nights) }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <svg class="loader my-3" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg" v-if="isLoadingCalendar && availabilities.length === 0 && initialLoads < maxInitialLoads">
                                <circle class="internal-circle" cx="60" cy="60" r="30"></circle>
                                <circle class="external-circle" cx="60" cy="60" r="50"></circle>
                            </svg>

                            <div class="alert alert-info mt-3" v-if="notAvailable">
                                {{ 'checkout.steps.calendar.noAvailabilitiesFound' | trans }}
                                <br />
                                <button type="button" class="btn btn-outline-info btn-sm mt-2" @click.prevent="loadCalendar">
                                    {{ 'checkout.steps.calendar.tryAgain' | trans }}
                                </button>
                            </div>

                            <div class="calendar-view mt-3" v-if="availabilities.length > 0 && currentMonth !== null">

                                <div class="d-flex">
                                    <!-- Prev month (button) -->
                                    <div class="ml-3">
                                        <button type="button" class="btn btn-outline-dark calendar-control" @click="prevMonth()" :disabled="isLoading !== false || ! (parseInt(currentMonth.format('M'), 10) > parseInt(today.format('M'), 10) || parseInt(currentMonth.format('YYYY'), 10) > parseInt(today.format('YYYY'), 10))">
                                            <i class="fa fa-chevron-left"></i>
                                        </button>
                                    </div>

                                    <!-- Current month -->
                                    <div class="px-2 flex-grow-1">
                                        <span class="current-month">
                                            {{ currentMonth.format('MMMM YYYY') }}

                                            <i class="fa fa-spinner fa-spin" v-if="isLoadingCalendar"></i>
                                        </span>
                                    </div>

                                    <!-- Next month (button) -->
                                    <div class="mr-3">
                                        <button type="button" class="btn btn-outline-dark calendar-control" @click="nextMonth()" :disabled="isLoading !== false">
                                            <i class="fa fa-chevron-right"></i>
                                        </button>
                                    </div>
                                </div>

                                <!-- Seaons -->
                                <div class="seasons px-2" v-if="currentSeasons && currentSeasons.length > 0">
                                    <span v-for="season in currentSeasons">
                                        <span class="cell-indicator" :class="'color-' + season.color"></span>

                                        {{ season.name }}
                                        <small>
                                            ({{ season.info }})
                                        </small>
                                    </span>
                                </div>

                                <div class="months">
                                    <div>
                                        <table :class="{ 'is-loading': (isLoading === 'loadCalendar' || isLoading === 'loadFilters') && availabilities.length > 0 }">
                                            <!-- Header -->
                                            <thead>
                                                <tr>
                                                    <th>
                                                        {{ 'general.shortWeekdayByNumber.1' | trans }}
                                                    </th>
                                                    <th>
                                                        {{ 'general.shortWeekdayByNumber.2' | trans }}
                                                    </th>
                                                    <th>
                                                        {{ 'general.shortWeekdayByNumber.3' | trans }}
                                                    </th>
                                                    <th>
                                                        {{ 'general.shortWeekdayByNumber.4' | trans }}
                                                    </th>
                                                    <th>
                                                        {{ 'general.shortWeekdayByNumber.5' | trans }}
                                                    </th>
                                                    <th class="weekend">
                                                        {{ 'general.shortWeekdayByNumber.6' | trans }}
                                                    </th>
                                                    <th class="weekend">
                                                        {{ 'general.shortWeekdayByNumber.0' | trans }}
                                                    </th>
                                                </tr>
                                            </thead>

                                            <!-- Body -->
                                            <tbody>
                                                <tr v-for="(week, weekIndex) in currentCalendar">
                                                    <!-- Fill up days -->
                                                    <td v-for="index in week[0].date.format('E') - 1" class="space-filler">
                                                        <span>
                                                            {{ week[0].date.clone().subtract(week[0].date.format('E') - index, 'days').format('D') }}
                                                        </span>
                                                    </td>

                                                    <td v-for="day in week" :class="{ 'available': (day.available && selectablePeriod === null) || (selectablePeriod !== null && selectablePeriod.contains(day.date)), 'booked-out': day.booked_out && !day.available, 'arrive-date': arriveDate !== null && day.date.format('YYYY-MM-DD') === arriveDate.format('YYYY-MM-DD'), 'departure-date': departureDate !== null && day.date.format('YYYY-MM-DD') === departureDate.format('YYYY-MM-DD'), 'travel-day': arriveDate !== null && travelPeriod !== null && travelPeriod.contains(day.date), 'cheapest': typeof(day.cheapest) !== 'undefined' && day.cheapest === true && 1 === 2, 'without-extra-charge': day.available && day.price <= 0, 'with-extra-charge': day.available && day.price > 0 }" @click="() => {
                                                        if (selectablePeriod === null) {
                                                            setArriveDate(day)
                                                        } else {
                                                            setDepartureDate(day)
                                                        }
                                                    }">

                                                        <!-- Close btn -->
                                                        <div class="close-btn" v-if="arriveDate !== null && day.date.format('YYYY-MM-DD') === arriveDate.format('YYYY-MM-DD')" @click.stop="resetArriveDate()">
                                                            <i class="wa-icon-close"></i>
                                                        </div>

                                                        <span :class="'color-' + day.color">
                                                            <span class="day">
                                                                {{ day.date.format('D') }}
                                                            </span>

                                                            <!-- Price -->
                                                            <small class="price" v-if="day.available && showCalendarPrices && !day.is_on_request">
                                                                {{ day.price | formatPrice  }} &euro;
                                                            </small>

                                                            <!-- On request -->
                                                            <small class="on-request" v-if="day.available && day.is_on_request">
                                                                <i class="fa fa-search"></i>
                                                            </small>

                                                            <!-- Sold out -->
                                                            <small class="sold-out" v-if="day.booked_out">
                                                                {{ 'checkout.steps.calendar.soldOut' | trans }}
                                                            </small>
                                                        </span>
                                                    </td>

                                                    <!-- Fill up days -->
                                                    <td v-for="index in 7 - week[week.length - 1].date.format('E')" class="space-filler" :class="{ 'travel-day': arriveDate !== null && travelPeriod !== null && travelPeriod.contains(week[week.length - 1].date.clone().add(index, 'days')) }">
                                                        <span>
                                                            {{ week[week.length - 1].date.clone().add(index, 'days').format('D') }}
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
    </div>
</template>

<script>
    export default {
        props: ['tripId', 'voucherId', 'host'],
        data: function() {
            return {
                // Helpers
                showDropdown: null,
                isError: false,
                isLoading: false,
                isLoadingCalendar: false,
                today: null,
                currentMonth: null,
                currentSeasons: [],
                initialLoads: 0,
                maxInitialLoads: 12,
                showCalendarPrices: false,
                firstPageLoad: true,
                firstAvailableFound: false,
                checkoutShowDiscountForm: false,
                isVoucher: false,
                isRunningRateCheck: false,
                rateCheckData: null,

                // Filters
                filters: {
                    nights: null,
                },
                isChildren: false,
                isPersonsValid: true,
                adults: 2,
                children: [],
                tmpAdults: 2,
                tmpChildren: [],
                possibleNights: [],
                availabilities: [],
                arriveDate: null,
                departureDate: null,
                selectablePeriod: null,
            }
        },
        mounted: function() {
            // this.today = this.$moment().subtract(2, 'years').subtract(4, 'months');
            this.today = this.$moment();
            this.currentMonth = this.$moment((this.today.format('YYYY-MM') + '-01'), 'YYYY-MM-DD');

            this.loadPersons();
        },
        computed: {
            notAvailable() {
                let availableIndex = _.findIndex(this.availabilities, { available: true })

                return this.availabilities.length > 0 && availableIndex === -1
            },
            nights() {
                if (! this.arriveDate || ! this.departureDate) {
                    return null
                }

                return this.departureDate.diff(this.arriveDate, 'days')
            },
            travelPeriod() {
                if (! this.arriveDate || ! this.departureDate) {
                    return null
                }

                return this.$moment().range(this.arriveDate.clone(), this.departureDate.clone());
            },

            currentCalendar: function() {
                let from = this.currentMonth.startOf('month').clone()
                let to = this.currentMonth.endOf('month').clone()

                // Extend to selectable period
                if (this.selectablePeriod && to.isBefore(this.selectablePeriod.end)) {
                    to = this.selectablePeriod.end.clone()
                }

                // Extend to departure date
                if (this.departureDate && to.isBefore(this.departureDate)) {
                    to = this.departureDate.clone()
                }

                // Build range
                let range = moment().range(from, to)

                let calendar = []
                for (let day of range.by('days')) {
                    calendar.push({
                        date: day.clone(),
                    })
                }

                // Filter availabilities
                let availabilities = this.availabilities.filter((availability) => range.contains(availability.date))

                // Apply filters
                // Nights filter
                if (this.filters.nights) {
                    availabilities = availabilities.map((availability) => {
                        let price = _.find(availability.price_per_days, { days: this.filters.nights + 1 })
                        return {
                            ...availability,
                            available: availability.available && this.filters.nights + 1 >= availability.min_days && this.filters.nights + 1 <= availability.max_days,
                            price: price ? price.price : availability.price,
                        }
                    })
                }

                calendar = calendar.map((day) => {
                    let found = null

                    // Try to find availability
                    availabilities.forEach((availability) => {
                        if (availability.date.isSame(day.date)) {
                            found = availability
                        }
                    })

                    return found || day
                })

                // Group by iso week
                return _.groupBy(calendar, function(availability) {
                    return availability.date.isoWeek();
                });
            },

            // Voucher code
            voucherCode: function() {
                return $cookies.get('wa_voucherCode')
            },
        },
        watch: {
            filters: {
                handler(val) {
                    // Automatically adjust length of stay when nights are selected
                    if (this.filters.nights && this.arriveDate) {
                        this.departureDate = this.arriveDate.clone().add(this.filters.nights, 'days')
                    }
                    if (this.filters.nights) {
                        this.jumpToFirstMonth()
                    }
                },
                deep: true
            }
        },
        methods: {
            jumpToFirstMonth() {
                var firstAvailableDate = null;
                var isCurrentMonthAvailable = false;
                for (var i = 0; i < this.availabilities.length; i++) {
                    if (this.isAvailable(this.availabilities[i])) {
                        if (! firstAvailableDate) {
                            firstAvailableDate = this.availabilities[i].date.clone()
                        }
                        if (this.availabilities[i].date.format('YYYY-MM') === this.currentMonth.format('YYYY-MM')) {
                            isCurrentMonthAvailable = true;
                        }
                    }
                }

                if (! isCurrentMonthAvailable && firstAvailableDate) {
                    this.currentMonth = firstAvailableDate.startOf('month').clone();
                }
            },

            isAvailable(day) {
                if (! day.available) {
                    return false
                }

                // Filters
                // Nights
                if (this.filters.nights !== null && ! (this.filters.nights + 1 >= day.min_days && this.filters.nights + 1 <= day.max_days)) {
                    return false
                }

                return true
            },

            // Dropdowns
            toggleDropdown: function(dropdownName) {
                this.showDropdown = this.showDropdown === dropdownName ? null : dropdownName;
            },

            // Persons
            loadPersons: function() {
                var self = this;
                this.isLoading = 'loadPersons';
                this.isPersonsValid = true;

                axios.get(route('api.checkout.persons', {}, true, this.host), {
                    params: {
                        trip_id: this.tripId,
                        voucher_code: this.voucherCode
                    }
                }).then(function (response) {
                    self.isChildren = response.data.data.children;
                    if (response.data.data.min_selection_persons !== null && response.data.data.min_selection_persons > 2) {
                        self.adults = response.data.data.min_selection_persons;
                    }
                    self.isLoading = false;
                    self.loadFilters()
                    self.loadCalendar();
                }).catch(function (error) {
                    console.log(error);
                    self.isError = true;
                    self.isLoading = false;
                });
            },
            increaseChildren: function() {
                this.children.push({
                    id: this.children.length,
                    birthdate: {
                        day: null,
                        month: null,
                        year: null
                    }
                });
                setTimeout(function() {
                    $('div.checkout div.calendar div.children-age').last().find('div.birthdate input.day').focus();
                }, 200)
            },
            decreaseChildren: function() {
                this.children.pop();
            },
            calculateChildAge: function(child) {
                return this.$moment().diff(this.getChildBirthdateString(child), 'years', false);
            },
            getChildBirthdateString: function(child) {
                var year = child.birthdate.year;
                var month = parseInt(child.birthdate.month, 10) < 10 ? '0' + parseInt(child.birthdate.month, 10) : '' + child.birthdate.month;
                var day = parseInt(child.birthdate.day, 10) < 10 ? '0' + parseInt(child.birthdate.day, 10) : '' + child.birthdate.day;
                var birthdateString = year + '-' + month + '-' + day;

                return birthdateString;
            },
            clearBirthdateInput: function(event) {
                event.target.value = '';
            },
            validateEnterBirthdate: function(event) {
                var value = event.target.value;
                var newValue = parseInt('' + event.target.value + event.key, 10);

                if (event.key === 'Backspace') return true;

                // Max length
                switch (event.target.className) {
                    case 'day':
                        if (value.length > 2 || newValue > 31) {
                            event.preventDefault();
                        } else if (value.length === 2) {
                            event.target.value = '';
                        }
                        break;

                    case 'month':
                        if (value.length > 2 || newValue > 12) {
                            event.preventDefault();
                        } else if (value.length === 2) {
                            event.target.value = '';
                        }
                        break;

                    case 'year':
                        if (value.length > 4) {
                            event.preventDefault();
                        } else if (value.length === 4) {
                            event.target.value = '';
                        }
                        break;
                }
            },
            jumpEnterBirthdate: function(event) {
                if (event.target.className !== 'year' && event.target.value.length === 2) {
                    event.target.nextElementSibling.focus();
                }
            },
            buildPersons: function() {
                var persons = [];
                persons.push({
                    type: 'adult',
                    birthdate: '1990-01-01',
                    amount: this.adults
                });

                for (var i = 0; i < this.children.length; i++) {
                    var child = this.children[i];
                    persons.push({
                        type: 'child',
                        birthdate: this.getChildBirthdateString(child),
                        amount: 1
                    });
                }

                return persons;
            },
            applyPersons: function(dropdownName) {
                var self = this;
                this.isLoading = 'applyPersons';
                this.isPersonsValid = true;

                axios.post(route('api.checkout.checkPersons', {}, true, this.host), {
                    trip_id: this.tripId,
                    persons: this.buildPersons(),
                    voucher_code: this.voucherCode
                }).then(function (response) {
                    self.isPersonsValid = response.data.data.valid;
                    self.isLoading = false;

                    // Valid persons
                    if (response.data.data.valid === true) {
                        self.tmpAdults = JSON.parse(JSON.stringify(self.adults));
                        self.tmpChildren = JSON.parse(JSON.stringify(self.children));

                        self.toggleDropdown(dropdownName);

                        // Reset availabilities
                        self.availabilities = []

                        self.resetArriveDate();

                        // Refresh calendar
                        self.loadCalendar();

                        // Refresh filters
                        self.loadFilters()

                        // Init calendar
                        // if (self.availabilities.length === 0) {
                        //  self.initCalendar();
                        // }
                    }
                }).catch(function (error) {
                    console.log(error);
                    self.isError = true;
                    self.isLoading = false;
                });
            },
            togglePersonsDropdown: function(dropdownName) {
                if (this.showDropdown === dropdownName) {
                    this.adults = JSON.parse(JSON.stringify(this.tmpAdults));
                    this.children = JSON.parse(JSON.stringify(this.tmpChildren));
                } else {
                    this.tmpAdults = JSON.parse(JSON.stringify(this.adults));
                    this.tmpChildren = JSON.parse(JSON.stringify(this.children));
                }
                this.isPersonsValid = true;

                this.toggleDropdown(dropdownName);
            },

            // Filters
            loadFilters: function() {
                var self = this;
                this.isLoading = 'loadFilters';

                axios.post(route('api.checkout.filters', {}, true, this.host), {
                    trip_id: this.tripId,
                    persons: this.buildPersons(),
                    date_from: this.currentMonth.clone().format('YYYY-MM-DD'),
                    date_to: this.currentMonth.clone().add(1, 'years').format('YYYY-MM-DD'),
                    voucher_code: this.voucherCode
                }).then(function (response) {
                    self.possibleNights = response.data.data.nights;

                    // Check if possible nights contains current nights
                    if (self.nights !== null) {
                        var currentNightsFound = false;
                        for (var i = 0; i < self.possibleNights.length; i++) {
                            if (self.possibleNights[i].amount == self.nights) {
                                currentNightsFound = true;

                                // Refresh calendar
                                // self.loadCalendar();
                            }
                        }

                        if (!currentNightsFound) self.nights = self.possibleNights[0].amount;
                    } else {
                        // self.nights = self.possibleNights[0].amount;
                        // self.loadCalendar()
                    }

                    self.isLoading = false;
                }).catch(function (error) {
                    console.log(error);
                    self.isError = true;
                    self.isLoading = false;
                });
            },

            // Calendar
            loadCalendar: function() {
                var self = this;
                this.isLoadingCalendar = true

                axios.post(route('api.checkout.calendar', {}, true, this.host), {
                    trip_id: this.tripId,
                    persons: this.buildPersons(),
                    voucher_id: this.voucherId,
                    year: this.currentMonth.format('YYYY'),
                    month: this.currentMonth.format('M'),
                }).then(function (response) {
                    // Calendar
                    var availabilities = response.data.data;

                    // Seasons
                    var seasons = response.data.seasons;
                    for (var i = 0; i < seasons.length; i++) {
                        for (var k = 0; k < seasons[i].periods.length; k++) {
                            seasons[i].periods[k].date_from = self.$moment(seasons[i].periods[k].date_from, 'YYYY-MM-DD');
                            seasons[i].periods[k].date_to = self.$moment(seasons[i].periods[k].date_to, 'YYYY-MM-DD');
                        }
                    }
                    self.currentSeasons = seasons;

                    // Parse dates
                    for (var i = 0; i < availabilities.length; i++) {
                        availabilities[i].date = self.$moment(availabilities[i].date, 'YYYY-MM-DD');
                    }

                    // Set first month
                    var availableFound = false;
                    for (var i = 0; i < availabilities.length; i++) {
                        if (availabilities[i].available === true) {
                            availableFound = true;
                            self.firstAvailableFound = true;
                            break;
                        }
                    }

                    // Check arrive date
                    var arriveDate = false;
                    if (self.arriveDate !== null) {
                        for (var i = 0; i < availabilities.length; i++) {
                            if (availabilities[i].date.format('YYYY-MM-DD') === self.arriveDate.format('YYYY-MM-DD') && availabilities[i].available) {
                                self.setArriveDate(availabilities[i]);
                                arriveDate = true;
                            }
                        }
                    }
                    if (!arriveDate) self.resetArriveDate();

                    self.isLoadingCalendar = false;

                    if (! availableFound && ! self.firstAvailableFound) {
                        if (self.initialLoads <= self.maxInitialLoads) {
                            self.nextMonth();
                        } else {
                            self.isLoadingCalendar = false;
                        }
                        self.initialLoads++;
                        return
                    }

                    let existingAvailabilities = self.availabilities
                    let slicedAvailabilities = availabilities.slice()

                    // Delete existing dates which are available in response
                    existingAvailabilities = existingAvailabilities.filter((availability) => {
                        let shouldDelete = false
                        slicedAvailabilities.forEach((day) => {
                            if (day.date.isSame(availability.date)) {
                                shouldDelete = true
                            }
                        })

                        return ! shouldDelete
                    })

                    // Update availabilities after sorting them
                    self.availabilities = [...existingAvailabilities, ...slicedAvailabilities].sort((a, b) => {
                        return a.date.format('YYYYMMDD') - b.date.format('YYYYMMDD')
                    })

                    // Update current month
                    if (self.initialLoads === 0) {
                        self.jumpToFirstMonth()
                    }
                }).catch(function (error) {
                    console.log(error);
                    self.isError = true;
                    self.isLoading = false;
                });
            },
            setArriveDate: function(day) {
                if (day.available) {
                    this.arriveDate = day.date.clone();
                    // this.nights = null;
                    if (this.filters.nights) {
                        this.departureDate = this.arriveDate.clone().add(this.filters.nights, 'days')
                        this.selectablePeriod = null
                    } else {
                        this.departureDate = null;

                        this.selectablePeriod = this.$moment().range(
                            day.date.clone().add(day.min_days - 1, 'days'),
                            day.date.clone().add(day.max_days - 1, 'days')
                            );
                    }
                }
            },
            setDepartureDate: function(day) {
                if (this.selectablePeriod.contains(day.date)) {
                    this.departureDate = day.date.clone();
                    this.selectablePeriod = null;
                }
            },
            resetArriveDate: function() {
                this.arriveDate = null;
                this.departureDate = null;
                this.selectablePeriod = null;

                //this.$forceUpdate();
            },
            nextMonth: function() {
                this.resetArriveDate();
                this.currentMonth = this.currentMonth.clone().add('1', 'months');

                this.checkReload()
                //this.$forceUpdate();
            },
            prevMonth: function() {
                this.resetArriveDate();
                this.currentMonth = this.currentMonth.clone().subtract('1', 'months');

                this.checkReload()
            },
            checkReload: function() {
                // Check if need to load calendar data
                let currentMonth = this.currentMonth
                let foundDates = this.availabilities.filter((day) => day.date.isSame(currentMonth, 'month'))
                if (foundDates.length == 0) {
                    this.loadCalendar()
                }
            },
            initCalendar: function() {
                this.initialLoads = 0;
                this.resetArriveDate();

                this.today = this.$moment();
                this.currentMonth = this.$moment((this.today.format('YYYY-MM') + '-01'), 'YYYY-MM-DD');
            },

            // Mobile summary
            toggleMobileSummary: function() {
                $('div.checkout').toggleClass('show-summary');
            },
        }
    }
</script>
